import React from 'react';
import CardEvent from '../CardEvent/CardEvent';
import { pathToModel } from '../../../utils';

const EventList = ({ events = [] }) => {
  return (
    <>
      {events.map((e) => {
        const url = pathToModel(e.node?.model?.apiKey || e.model?.apiKey, e.node?.slug || e.slug);

        return (
          <CardEvent
            key={e.node?.id || e.id}
            url={url}
            title={e.node?.title || e.title}
            day={e.node?.date || e.date}
            hour={e.node?.time || e.time}
            color={e.node?.tags?.color || e.tags?.color}
            image={e.node?.image || e.image}
            tag={e.node?.tags?.title || e.tags?.title}
            type={e.node?.eventType || e.eventType}
            description={e.node?.summary || e.summary}
            fullDate={e.node?.fullDate || e.fullDate}
            location={e.node?.location || e.location}
          />
        );
      })}
    </>
  );
};

export default EventList;
